// src/utils/auth.js

// -------------------------------
// Decodificar un JWT de forma segura
// -------------------------------
function decodeJWT(token) {
  try {
    const payloadBase64 = token.split(".")[1];
    const payloadJson = atob(payloadBase64);
    return JSON.parse(payloadJson);
  } catch (e) {
    return null;
  }
}

// -------------------------------
// Validar si el token existe y no está expirado
// -------------------------------
export function isAuthenticated() {
  const token = localStorage.getItem("auth_token");
  if (!token) return false;

  const payload = decodeJWT(token);
  if (!payload) {
    logout();
    return false;
  }

  const expMs = payload.exp * 1000;
  const ahora = Date.now();

  if (ahora >= expMs) {
    console.warn("JWT expirado → cerrando sesión automáticamente.");
    logout();
    return false;
  }

  return true;
}

// -------------------------------
// Obtener usuario completo
// -------------------------------
export function getCurrentUser() {
  if (!isAuthenticated()) return null;

  return {
    nombre: localStorage.getItem("auth_nombre") || "",
    correo: localStorage.getItem("auth_correo") || "",
    rol: localStorage.getItem("auth_rol") || "",
    numcliente: localStorage.getItem("auth_numcliente") || "",
    token: localStorage.getItem("auth_token"),
  };
}

// -------------------------------
// Obtener solo el token
// -------------------------------
export function getToken() {
  return isAuthenticated() ? localStorage.getItem("auth_token") : null;
}

// -------------------------------
// Logout seguro
// -------------------------------
export function logout() {
  localStorage.removeItem("auth_token");
  localStorage.removeItem("auth_nombre");
  localStorage.removeItem("auth_correo");
  localStorage.removeItem("auth_rol");
  localStorage.removeItem("auth_correo_pendiente");
  localStorage.removeItem("auth_numcliente");
}

// -------------------------------
// Helpers de rol
// -------------------------------
export function hasRole(role) {
  const user = getCurrentUser();
  return user && user.rol === role;
}

export function isCliente() {
  return hasRole("cliente");
}

export function isEspecialista() {
  return hasRole("especialista");
}
